import { interpolate, toText } from "./fable_modules/fable-library-js.4.24.0/String.js";
import { defaultArg } from "./fable_modules/fable-library-js.4.24.0/Option.js";
import { tryItem } from "./fable_modules/fable-library-js.4.24.0/Array.js";

export function Colors_LightBlue(a) {
    return toText(interpolate("rgba(98, 181, 229, %.2f%P())", [a]));
}

export const Colors_AlertsPositiveDark = "#1E5722";

export function Colors_docTreeLayerToColor(layer) {
    return defaultArg(tryItem(layer, ["#ffffff", "#f9f9f9", "#dddddd", "#cccccc", "#bbbbbb"]), "#76aede");
}

export const Styles_textOverflow = [["overflow", "hidden"], ["whiteSpace", "nowrap"], ["textOverflow", "ellipsis"]];

